'use strict';

if (!Amisco) {
    var Amisco = {};
}

Amisco.Modal = {};

Amisco.Modal.initImageModal = function () {
    $('.js-modal-image').modaal({
        type: 'image',
        after_open: function after_open(modal) {
            Amisco.Modal.initCloseOnBkgClick();

            var content = modal.find('.modaal-container');

            /*content.on( 'swipeleft', function() {
                modal.find( '.modaal-gallery-next' ).trigger( 'click' );
            } );
             content.on( 'swiperight', function() {
                modal.find( '.modaal-gallery-prev' ).trigger( 'click' );
            } );*/
        }
    });
};

Amisco.Modal.initInlineModal = function () {
    $.each($('.js-modal-inline'), function (index, modal) {
        var modal = $(modal);

        var modalDefaultSettings = {
            type: 'inline',
            after_open: Amisco.Modal.initCloseOnBkgClick
        };

        modal.modaal(Amisco.Modal.inlineSettings(modal, modalDefaultSettings));
    });
};

Amisco.Modal.inlineSettings = function (modal, modalDefaultSettings) {

    if (modal.data('modal-css-class')) {
        modalDefaultSettings.custom_class = modal.data('modal-css-class');
    }

    if (modal.data('modal-width')) {
        modalDefaultSettings.width = modal.data('modal-width');
    }

    if (modal.data('modal-height')) {
        modalDefaultSettings.height = modal.data('modal-height');
    }

    if (modal.data('fullscreen')) {
        modalDefaultSettings.fullscreen = true;
    }

    return modalDefaultSettings;
};

Amisco.Modal.initCloseOnBkgClick = function () {
    $('.modaal-wrapper').on('click', function (e) {
        var target = $(e.target);

        if (target.hasClass('modaal-wrapper')) {
            e.preventDefault();
            e.stopPropagation();

            target.find('.modaal-close').trigger('click');
        }
    });
};

Amisco.Modal.init = function () {
    Amisco.Modal.initImageModal();
    Amisco.Modal.initInlineModal();
};

$(document).init('ready', Amisco.Modal.init);